import { cx } from '@linaria/core';
import { forwardRef } from 'react';
import { MoveFocusInside } from 'react-focus-on';
import { Button } from '../components/buttons/button.js';
import { Link } from '../components/buttons/link.js';
import { DialogContent } from '../components/overlays/dialog.js';
import { CloseButton } from '../components/overlays/util.close-button.js';
import { dialog, heading, body, footerRule, footerBody, actionList } from './molecule.dialog.style.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';

const Dialog = /*#__PURE__*/forwardRef(function Dialog(props, ref) {
  const onCloseRequest = () => {
    if (props.model.requiresAction) {
      return;
    }
    props.model.onSelect(undefined);
  };
  return /*#__PURE__*/jsxs(DialogContent, {
    ref: ref,
    className: cx(dialog, props.model.className),
    requiresInteraction: props.model.requiresAction,
    includeSpeechButton: props.model.includeSpeechButton,
    onClose: onCloseRequest,
    children: [/*#__PURE__*/jsx("h1", {
      className: heading,
      children: props.model.heading
    }), /*#__PURE__*/jsx("div", {
      className: body,
      children: props.model.body
    }), /*#__PURE__*/jsx(Actions, {
      actions: props.model.actions,
      onSelect: props.model.onSelect
    }), props.model.footer && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx("hr", {
        className: footerRule
      }), /*#__PURE__*/jsx("div", {
        className: footerBody,
        children: props.model.footer.body
      }), props.model.footer.actions && /*#__PURE__*/jsx(Actions, {
        actions: props.model.footer.actions,
        onSelect: props.model.onSelect
      })]
    }), !props.model.requiresAction && /*#__PURE__*/jsx(CloseButton, {
      label: "Luk dialog",
      onClose: onCloseRequest
    })]
  });
});
function Actions(props) {
  return /*#__PURE__*/jsx("ul", {
    className: actionList,
    children: props.actions.map((action, index) => {
      const content = "href" in action ? /*#__PURE__*/jsx(Link, {
        href: action.href,
        theme: action.type,
        onClick: () => props.onSelect(undefined),
        children: action.label
      }) : /*#__PURE__*/jsx(Button, {
        theme: action.type,
        onClick: () => props.onSelect(action.intent),
        children: action.label
      });
      if (action.type === "primary") {
        return /*#__PURE__*/jsxs("li", {
          children: [/*#__PURE__*/jsx(MoveFocusInside, {
            children: content
          }), " "]
        }, index);
      } else {
        return /*#__PURE__*/jsx("li", {
          children: content
        }, index);
      }
    })
  });
}

export { Dialog };
//# sourceMappingURL=molecule.dialog.js.map
